import styled from "styled-components";

import { BillingFormModalStyledProps as Props } from "./BillingFormModal.types";

const BillingFormModalStyled = styled.div<Props>`
  .BillingFormModal {
  }
`;

export default BillingFormModalStyled;
